import { apiDietPrices } from './apiDietPrices'
import { apiPriceDiets } from './apiPriceDiets'
import { apiPriceTiers } from './apiPriceTiers'

const apiPrices = {
	...apiDietPrices,
	...apiPriceTiers,
	...apiPriceDiets,
}

export { apiPrices }
